var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaithSharing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6375 9.26855C5.27734 9.26855 5.81875 9.80996 5.81875 10.4498V10.8436L7.59063 9.51465C7.7875 9.36699 8.03359 9.26855 8.3043 9.26855H11.725C11.9219 9.26855 12.1188 9.09629 12.1188 8.8748V1.7873C12.1188 1.59043 11.9219 1.39355 11.725 1.39355H2.275C2.05352 1.39355 1.88125 1.59043 1.88125 1.7873V8.8748C1.88125 9.09629 2.05352 9.26855 2.275 9.26855H4.6375ZM5.81875 12.3201L5.79414 12.3447L5.67109 12.4186L5.25273 12.7385C5.12969 12.8369 4.98203 12.8369 4.83437 12.7877C4.71133 12.7139 4.6375 12.5908 4.6375 12.4186V11.9018V11.7541V11.7295V11.6311V10.4498H3.45625H2.275C1.38906 10.4498 0.7 9.76074 0.7 8.8748V1.7873C0.7 0.925976 1.38906 0.212304 2.275 0.212304H11.725C12.5863 0.212304 13.3 0.925976 13.3 1.7873V8.8748C13.3 9.76074 12.5863 10.4498 11.725 10.4498H8.3043L5.81875 12.3201Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaithSharing);
export default __webpack_public_path__ + "static/media/faith-sharing.bfc82df61bbb41f5643a56156c64c1f2.svg";
export { ForwardRef as ReactComponent };